import { useContext, createContext, useState } from "react";

const SpinnersContext = createContext({});
const SpinnersUpdateContext = createContext({});

export function useSpinnersContext() {
  return useContext(SpinnersContext);
}

export function useSpinnersUpdateContext() {
  return useContext(SpinnersUpdateContext);
}

export function SpinnersProvider({ children }) {
  const [spinners, setSpinners] = useState({});

  //context can store also functions, such as setters within the context itself
  const setSpinner = (newSpinners) => {
    setSpinners((prev) => ({
      ...prev,
      ...newSpinners,
    }));
  };

  return (
    <SpinnersContext.Provider value={spinners} displayName="SpinnersStore">
      <SpinnersUpdateContext.Provider value={setSpinner} displayName="SpinnersStoreUpdate">
        {children}
      </SpinnersUpdateContext.Provider>
    </SpinnersContext.Provider>
  );
}
